import React from 'react';
import HubPage from '../../ui-components/HubPage';

const ITEM_META = {
  '/MeetingDashboard': { icon: 'groups', desc: 'Opgenomen meetings met transcript, samenvatting en actiepunten (FF Recorder)' },
  '/weekplan': { icon: 'calendar_view_week', desc: 'Gisteren · vandaag · komende werkdagen — agenda, taken en Frits\' top 5, slepen om te plannen' },
  '/ai-mail': { icon: 'mark_email_read', desc: 'Mails die jij in Outlook als AI markeert: voorstel + concept, één klik goedkeuren' },
  '/mail-assistent': { icon: 'mail', desc: 'Frits triageert je inbox: samenvattingen, concept-antwoorden en acties — elke ochtend klaar' },
  '/vandaag': { icon: 'today', desc: 'Je dag in één overzicht — taken, agenda en updates' },
  '/overleg': { icon: 'event_note', desc: 'Mijn week: je overleggen met pakket en invulblok, je open acties en cijfers die je nog moet invullen' },
  '/overleg/acties': { icon: 'fact_check', desc: 'Eén actieregister over alle overleggen — eigenaar, deadline, status, te laat bovenaan' },
  '/dashboard': { icon: 'person', desc: 'Je persoonlijke dashboard per functie — taken, deadlines, meetings en projecten die om jou vragen' },
  '/mijn-taken': { icon: 'checklist', desc: 'Projecttaken: al je openstaande taken uit projecten — per project of plat op startdatum, deadline of prio' },
  '/mijn-todos': { icon: 'playlist_add_check', desc: 'Privé-to-do\'s: jouw Microsoft To Do, hier snel te vangen en te plannen in je Weekplan' },
  '/slim-uren': { icon: 'timer', desc: 'AI-gestuurd urenschrijven op basis van taken en agenda' },
  '/overdracht': { icon: 'swap_horiz', desc: 'Draag projecten tijdelijk over aan een collega — met automatisch stand-van-zaken-dossier' },
};

export default function MijnWerk() {
  return (
    <HubPage
      sectionKey="mijnwerk"
      subtitle="Je persoonlijke werkplek"
      headerIcon="work_outline"
    itemMeta={ITEM_META}
    />
  );
}
